var _title, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgTransactionPending = function SvgTransactionPending(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "140px",
    height: "100px",
    viewBox: "0 0 140 100",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "transaction_pending")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "current",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "transaction_pending",
    transform: "translate(5.000000, 23.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(0.000000, -0.000000)",
    stroke: "current",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9807692,7.64556885 L19.9807692,4.375 C19.9807692,1.95875422 21.9395235,0 24.3557692,0 L103.105769,0 C105.522015,0 107.480769,1.95875422 107.480769,4.375 L107.480769,43.75 C107.480769,46.1662458 105.522015,48.125 103.105769,48.125 L24.3557692,48.125 C21.9395235,48.125 19.9807692,46.1662458 19.9807692,43.75 L19.9807692,39.3920898",
    id: "Path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 64.7403846,
    cy: 25.9134615,
    r: 11.7788462
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.6875,
    y1: 13.125,
    x2: 32.9375,
    y2: 13.125,
    id: "Line-3",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 21.5,
    x2: 37.3125,
    y2: 21.875,
    id: "Line-3-Copy",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 30.5,
    x2: 32.9375,
    y2: 30.625,
    id: "Line-3-Copy-2",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(88.944434, 26.175158)",
    stroke: "current",
    strokeWidth: 1,
    fill: "var(--primaryIconColor)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "np_tick_684585_000000",
    transform: "translate(0.055566, 0.824842)",
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.25,0 C8.60434813,0 0,8.60434813 0,19.25 C0,29.8956519 8.60434813,38.5 19.25,38.5 C29.8956519,38.5 38.5,29.8956519 38.5,19.25 C38.5,8.60434813 29.8956519,0 19.25,0 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "np_time_2055748_000000",
    transform: "translate(20.028235, 20.028235) scale(-1, -1) translate(-20.028235, -20.028235) ",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1652337,7.4644714 C16.4884205,7.4644714 13.9424756,8.20848533 11.7288676,9.64243463 C11.1417963,9.9844207 10.9701029,10.7795583 11.3258684,11.3897154 C11.6740011,11.9867816 12.4691387,12.158475 13.0792957,11.8027095 C14.92694,10.6391106 17.0202899,10.0219129 19.1633059,10.0219129 C25.3976984,10.0219129 30.487468,15.1116825 30.487468,21.346075 C30.487468,27.5804675 25.3976984,32.6702371 19.1633059,32.6702371 L18.7597239,32.6620331 C18.3520912,32.6456979 17.932483,32.6051874 17.5024906,32.5424673 L17.4009331,32.5254714 L17.8131583,31.7007167 C18.1859452,31.0074393 17.6450999,30.1580912 16.847002,30.2100201 L11.8942093,30.3703125 C11.0491696,30.4237779 10.6173538,31.326372 11.091653,32.0131133 L13.9978701,36.0500562 L14.0813222,36.1489791 C14.5775675,36.6715734 15.4522066,36.5506873 15.7588649,35.8876305 L16.2729331,34.8584714 L16.0784132,34.8158651 C17.1075686,35.0635046 18.1354966,35.1851391 19.2025868,35.1851391 C22.8960171,35.1851391 26.3471628,33.7490749 28.9781234,31.1200045 C31.606821,28.4913069 33.0433851,25.0384666 33.0433851,21.3443409 C33.0064545,17.6018717 31.5659449,14.1534109 28.9407876,11.5296234 C26.3121997,8.90103546 22.8593594,7.4644714 19.1652337,7.4644714 Z",
    id: "Path",
    transform: "translate(21.969448, 21.969448) rotate(-315.000000) translate(-21.969448, -21.969448) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1663296,6.8205028 C16.5046094,6.23477337 17.1923382,6.00683559 17.830541,6.37539018 C18.468119,6.74320321 18.6141003,7.4526194 18.2758722,8.03825928 C17.9376541,8.62388183 17.2501034,8.85234699 16.6115291,8.48447548 C15.9740619,8.11582858 15.8281341,7.40608619 16.1663296,6.8205028 Z",
    id: "Path",
    transform: "translate(17.221103, 7.429628) rotate(-315.000000) translate(-17.221103, -7.429628) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7996065,10.7942233 C12.6567153,12.2701691 10.3704564,12.2209709 10.3704564,10.6466287 C10.3704564,9.0738102 12.6567153,9.02465962 12.7996065,10.499177 L12.8065949,10.6466287 L12.7996065,10.7942233 Z",
    id: "Path",
    transform: "translate(11.588526, 10.647219) rotate(-315.000000) translate(-11.588526, -10.647219) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.74910164,15.205473 C8.33469526,14.8672693 9.04443985,15.0132052 9.41306517,15.650698 C9.78169042,16.2890254 9.55374368,16.9767628 8.96800877,17.3150481 C8.38241515,17.6532517 7.67267056,17.5073158 7.30397433,16.8697003 C6.93541999,16.2314957 7.16336673,15.5437582 7.74910164,15.205473 Z",
    id: "Path",
    transform: "translate(8.358545, 16.260258) rotate(-315.000000) translate(-8.358545, -16.260258) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0101549,13.100338 C19.3704594,13.100338 18.8633723,13.6074251 18.8633723,14.2471205 L18.8639327,22.8504921 L18.8765049,22.9033123 C18.8808398,22.9165062 18.8866168,22.9332498 18.8943194,22.9555746 L18.9278414,23.0076607 L19.0371341,23.1169534 C19.0500779,23.1329337 19.0647151,23.1474442 19.080817,23.160221 L19.098,23.171 L19.1099959,23.1898152 L19.1536787,23.2330828 L19.189,23.254 L19.3009046,23.3666414 L24.0623426,26.9405558 C24.3157552,27.0945119 24.5314076,27.1699061 24.7504039,27.1699061 C25.1295256,27.1699061 25.4505016,27.0152247 25.6711866,26.70661 L25.7387495,26.6023198 C26.0250427,26.103491 25.9065765,25.4459597 25.4354762,25.1034843 L21.162,21.881 L21.1569288,14.2470404 C21.1569288,13.648844 20.7164088,13.1683757 20.1364481,13.1069719 L20.0101549,13.100338 Z",
    id: "Path",
    transform: "translate(22.378193, 20.135122) scale(1, -1) translate(-22.378193, -20.135122) "
  })))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTransactionPending, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/transaction_pending.08202080.svg";
export { ForwardRef as ReactComponent };